import { Popover } from 'bootstrap';
import { TouchSpin } from "../Project/Functions/TouchSpin";
import { RenderModal } from "../Project/Functions/RenderModal";

;(function ($) {
    'use strict';

    const pluginName = 'shoppingButton';

    function Plugin(elements) {
        this._name = pluginName;
        this.elements = $(elements);
        this.templates = {};

        this.init();
        return this;
    }

    $.extend(Plugin.prototype, {
        init: function () {
            if (this.elements.length === 0) {
                return;
            }

            const that = this;
            this.elements.each(function () {
                if ($(this).data(pluginName + '_done')) {
                    return;
                }

                $(this).data(pluginName + '_done', true);

                let itemId = $(this).data('item-id');
                if (itemId === '' || itemId === undefined) {
                    return;
                }

                let variant = $(this).data('variant') ?? 'base';
                let baseTpl = 'tpl--shopping-button';

                $(this).on('buy-data-loaded', function (e) {
                    if (e.article.isOnRequest || !e.price && e.article.isForSale) {
                        baseTpl = 'tpl--shopping-button-request';
                    }

                    let deactivated = false;
                    if (!e.article.isForSale ?? true) {
                        deactivated = true;
                    }

                    const tmplId = baseTpl + '--' + variant;
                    $(this).html(that.getTemplate(tmplId)(
                        {deactivated: deactivated}
                    ))

                    const min = e.article.minimumQuantity ?? 1;
                    const max = e.article.maximumQuantity ?? 999;

                    const numberInput = $(this).find('input[type="number"]');
                    numberInput.data('min', min);
                    numberInput.data('max', max);

                    TouchSpin.init(numberInput.toArray());

                    const prices = e.article.prices;
                    const buttonElement = $(this).find('.add-to-cart');
                    $(buttonElement).on('click', function (e) {
                        e.preventDefault();

                        if (deactivated) {
                            that.showDropup(buttonElement, 'deactivated-dropup--tpl', {});
                            return false;
                        }

                        that.addToCart(itemId, prices, this);
                        return false;
                    });

                    buttonElement[0].addEventListener('plandent.productSlider.addToCart', () => {
                        if (deactivated) {
                            that.showDropup(buttonElement[0], 'deactivated-dropup--tpl', {});
                            return;
                        }

                        that.addToCart(itemId, prices, buttonElement[0]);
                    });
                });
            });
        },
        getTemplate(id) {
            if (this.templates[id] === undefined) {
                this.templates[id] = _.template($('#' + id).html());
            }

            return this.templates[id];
        },
        showDropup: function (buttonElement, dropupTmpl, dropupData) {
            $('.dropup.open').trigger('hide.bs.dropdown');

            const dropupContent = $(buttonElement).siblings('.shopping-button-dropup');
            dropupContent.html(this.getDropupContent(dropupTmpl, dropupData));

            let wrapper = buttonElement.closest('[data-plandent-action="shopping-button-popover"]');
            if (!wrapper) {
                return;
            }

            if (wrapper instanceof jQuery) {
                wrapper = wrapper[0];
            }

            const popoverContent = wrapper.querySelector('[data-plandent-shopping-button="content"]').innerHTML;

            const popover = new Popover(buttonElement, {
                html: true,
                content: () => {
                    return popoverContent;
                },
                trigger: 'manual',
                customClass: 'shopping-button-dropup-popover',
                popperConfig: {
                    placement: 'top-end'
                }
            });
            popover.show();

            async function autoHidePopover() {
                await setTimeout(() => {
                    popover.hide();
                }, 5000);
            }
            autoHidePopover();
        },
        addToCart: function (itemId, prices, buttonElement) {
            const inputElement = $(buttonElement).siblings('.bootstrap-touchspin').find('.quantity-input');
            const i = $(buttonElement).find('i');
            const that = this;

            $(buttonElement).addClass('disabled');
            $(buttonElement).attr('aria-disabled', true);

            i.removeClass('ai-shopping-cart');
            i.addClass('ai-refresh');

            const quantity = $(inputElement).val()

            $.ajaxq('cartInsert', {
                url: '/avency-nwd-shopping-lists/add.json',
                data: {itemId: itemId, quantity: quantity},
                type: 'post',
                success: function (response) {
                    if (response.redirect) {
                        const cartAddedRedirectEvent = new CustomEvent('plandent.cart.addedWithRedirect',
                            {
                                detail: {
                                    itemId: itemId,
                                    redirect: response.redirect
                                },
                                cancelable: true
                            }
                        );
                        document.dispatchEvent(cartAddedRedirectEvent);
                        if (!cartAddedRedirectEvent.defaultPrevented) {
                            window.location.href = response.redirect;
                        }
                        return;
                    }
                    const cartAddedEvent = new CustomEvent('plandent.cart.added', {detail: {itemId: itemId}});
                    document.dispatchEvent(cartAddedEvent);

                    if (!response.error) {
                        window.updateCartPreviewCount(response);

                        $(inputElement).val(1);
                        $(inputElement).trigger('touchspin.updatesettings', {min: 1, max: 999});
                    }

                    if (response.dropupTmpl !== undefined && response.dropupTmpl !== '') {
                        that.showDropup(buttonElement, response.dropupTmpl, response.dropupData);
                    }

                    if (response.modalStandalone !== undefined && response.modalStandalone !== '') {
                        $.ajax({
                            url: '/',
                            async: false,
                            data: {
                                'standalone': response.modalStandalone,
                                'referrer': window.location.href,
                                'article': itemId,
                                'quantity': quantity
                            },
                            success: function (data) {
                                RenderModal.init('', data);
                            }
                        })

                        i.addClass('ai-shopping-cart');
                        i.removeClass('ai-refresh');
                        $(buttonElement).attr('disabled', false);
                        return;
                    }

                    i.addClass('ai-shopping-cart');
                    i.removeClass('ai-refresh');

                    $(buttonElement).removeClass('disabled');
                    $(buttonElement).attr('aria-disabled', true);

                    if (!response.error) {
                        that.pushEcommerceDataLayer(itemId, response);
                        setCookie('reloadCart', 'true');
                    }
                }
            });
        },
        pushEcommerceDataLayer:  function (itemId, addResponse) {
            window.getPrice(itemId, addResponse.quantity, function (price) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addToCart',
                    'ecommerce': {
                        'currencyCode': 'EUR',
                        'add': {
                            'products': [{
                                'name': addResponse.name,
                                'id': itemId,
                                'price': price.unitPrice,
                                'brand': addResponse.manufacturer,
                                'quantity': addResponse.quantity
                            }]
                        }
                    }
                });
            });
        },
        getDropupContent: function (dropupTmpl, dropupData) {
            const tmpl = dropupTmpl ?? 'success-dropup--tpl';
            return this.getTemplate(tmpl)(dropupData);
        }
    });

    /**
     * Plugin Wrapper
     *
     * @param options
     * @returns {*}
     */
    $.fn[pluginName] = function (options) {
        if (options === undefined || typeof options === 'object') {
            return $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
    };
})(jQuery);
